"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_transition_group_1 = require("react-transition-group");
const transition_1 = require("../helper/transition");
const Backdrop = ({ showBackdrop, onHideBackdrop, className }) => (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: showBackdrop, classNames: "znd-main-navigation__content--transition", addEndListener: transition_1.defaultEndListener },
    react_1.default.createElement("div", { className: className, onClick: onHideBackdrop })));
exports.default = Backdrop;
